module.exports = __webpack_public_path__ + "static/media/elmiron.89778456.png";